import request from '@/utils/request'

/**
 * 获取图形验证码
 * @returns {*}
 */
export function getImgCode() {
  return request({
    url: '/captchaImage',
    headers: {
      isToken: false
    },
    method: 'get'
  })
}

/**
 * 获取用户信息
 * @returns {*}
 */
export function getUserInfo() {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}

/**
 * 登录
 * @param data
 * @returns {*}
 */
export function login(data) {
  return request({
    url: '/login',
    headers: {
      isToken: false
    },
    method: 'post',
    data
  })
}

/**
 * 退出
 * @param data
 * @returns {*}
 */
export function logout() {
  return request({
    url: '/logout',
    headers: {
      isToken: false
    },
    method: 'post'
  })
}

/**
 * 发送验证码
 * @param username
 * @param code
 * @param uuid
 * @returns {AxiosPromise}
 */
export function sendSmsVerificationCodeLite({ userName, code, uuid }) {
  return request({
    url: '/sendSmsVerificationCodeLite',
    headers: {
      isToken: false
    },
    method: 'post',
    data: { userName, code, uuid }
  })
}

/**
 * 验证码登录（注册）
 * @param username
 * @param smsCode
 * @param uuid
 * @param code
 * @returns {AxiosPromise}
 */
export function loginPlusWithSMS({ userName, smsCode, uuid, code }) {
  return request({
    url: '/loginPlusWithSMS',
    headers: {
      isToken: false
    },
    method: 'post',
    data: { userName, smsCode, uuid, code }
  })
}

/**
 * 卡号登录
 * @param username
 * @param smsCode
 * @param uuid
 * @param code
 * @returns {AxiosPromise}
 */
export function loginPlusWithCard({ userName, smsCode, uuid, code }) {
  return request({
    url: '/front/wishcase/wishUserDetail/loginWithCardNo',
    headers: {
      isToken: false
    },
    method: 'post',
    data: { userName, smsCode, uuid, code }
  })
}

/**
 * 学生号登录
 * @param {*} data 
 * @returns 
 */
export function loginWithDirect(data) {
  return request({
    url: '/loginDirect',
    headers: {
      isToken: false
    },
    method: 'post',
    data
  })
}

/**
 * 获取用户位置
 * @param data
 * @returns {AxiosPromise}
 */
export function getUserPosition(data) {
  return request({
    url: '/base/getUserPosition',
    method: 'post',
    data
  })
}

/**
 * 获取临时token
 */
export function getTempToken() {
  return request({
    url: '/front/exam/project/getUserToken',
    method: 'post',
    data: {}
  })
}

/**
 * 获取当前角色的动态菜单路由（管理端侧边栏数据源）
 */
export function getRouters() {
  return request({
    url: '/getRouters',
    method: 'get'
  })
}
